import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params, Router } from '@angular/router';
import { MobileReceiveVehicleService } from 'src/app/services/mobile/mobile-receive-vehicle.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-transfer-receive-vehicle',
  templateUrl: './transfer-receive-vehicle.component.html',
  styleUrls: ['./transfer-receive-vehicle.component.css']
})
export class TransferReceiveVehicleComponent implements OnInit{
  public vehicle_id: string = '';
  public isLoading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  vehicle: any;
  spare_parts: any;
  searchText: string = '';
  selectedSpareParts: any[] = []; // Array to store selected spare parts
  selectedSparePartsIDs: any[] = []; // Array to store selected spare parts IDs
  @ViewChild('confirmTransferModal') modalElement!: ElementRef;
  form!: FormGroup;
  submitted: boolean = false;
  locationId: any="";
  userId: any="";

  constructor(
    private mobileReceiveVehicleService: MobileReceiveVehicleService,
    private activatedRoute:ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private location: Location,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      driver_name:['',Validators.required],
      comment:['']
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;

      this.locationId=localStorage.getItem('locationId');
      this.userId=localStorage.getItem('userID');

      this.getVehicleData(this.vehicle_id);
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

  /**
   * Get vehicle details
   * @param vehicle_id
   */
   getVehicleData(vehicle_id: string): void{
    this.mobileReceiveVehicleService.getVehicleDetails(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            //Populate driver name on the driver's field
            this.form.patchValue({
              driver_name: this.vehicle.data.driver_name
            });

            //Fetch spare parts available when vehicle was transferred
            this.fetchSpareParts(this.vehicle.data.transfer_log_id);
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  fetchSpareParts(transfer_log_id: string):void{
    this.mobileReceiveVehicleService.getSparePartsAvailableOnRelease(transfer_log_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.spare_parts = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

   // Function to handle checkbox change event
  checkboxChange(event: any, part: any) {

    if (event.target.checked) {

      this.selectedSpareParts.push({
        part_id: part.id,
        name: part.name
      });

    } else {

      const index = this.selectedSpareParts.findIndex(
        item => item.part_id === part.id
      );

      if (index !== -1) {
        this.selectedSpareParts.splice(index, 1);
      }
    }
  }

  openModal(){
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  confirmTransfer(){
    if(this.selectedSpareParts.length===0){
      this.toastr.error("Please select available spare parts to proceed!", 'Error!');
    }else{
      this.openModal();

      //Clear previously selected spare parts IDs
      this.selectedSparePartsIDs.length = 0;

      this.selectedSpareParts.forEach(part => {
        this.selectedSparePartsIDs.push(
          part.part_id
        );
      });
    }
  }

  // Receive transferred vehicle
  releaseVehicle(){
    this.submitted = true;

    if(this.selectedSparePartsIDs.length===0){

      let errorMessage="Please select spare parts to proceed!";
      this.toastr.error(errorMessage, 'Error!');

    }else if(this.form.value.driver_name==''){
      this.isLoading=false;
      let errorMessage="Please enter driver's name to proceed!";
      this.toastr.error(errorMessage, 'Error!');

    }else{
      this.isLoading=true;

      this.mobileReceiveVehicleService.receive(this.vehicle_id, this.vehicle.data.chassis_no ,this.selectedSparePartsIDs, this.form.value.driver_name,this.locationId,this.form.value.comment, this.userId,this.vehicle.data.transfer_log_id)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
              //Clear selected spare parts arrays
              this.selectedSpareParts.length = 0;
              this.selectedSparePartsIDs.length = 0;

              this.isLoading=false;  //Dismiss spinner
              this. closeModal(); //Close modal
              // Store chassis No.,log Id and transaction type in session for use
              // when uploading photos
              localStorage.setItem('chassisNo', this.vehicle.data.chassis_no);
              localStorage.setItem('logId', response.log_id);
              localStorage.setItem('txnType', 'receive');

              // Redirect to photos  screen
              this.toastr.success(response.message, 'Success!');
              this.router.navigate(['mobile/vehicle-transfer-photos']);
          }else if(response.status==='error'){
            this.submitted = false;
            this.isLoading=false;
            this.errorMessage=response.message;
          }else{
            this.submitted = false;
            this.isLoading=false;
            this.toastr.error("Receiving Vehicle failed. Please try again!", 'Error!');
          }
        },
        error: (error) => {
          // Handle the error
          this.submitted = false;
          this.isLoading=false;
          this.toastr.error("An error occurred vehicle NOT received, please try again! ", 'Error!');
        }
      });
    }
  }

  goBack(): void {
    this.location.back();
  }
}
